import { Button, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import LoginApi from '../Login/api/LoginApi';
import { userProfileSelector, UserProfileSlice } from '../Login/reducers/UserProfileReducer';
import './RightMenu.scss';

const RightMenu: React.FunctionComponent = () => {
    const userProfile = useSelector(userProfileSelector);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <div className='user-analytics'>
                <div>Active since: {userProfile.analytics.lastActiveDate}</div>
                <div>Input: {userProfile.analytics.inputToday}/{userProfile.analytics.inputMonth}/{userProfile.analytics.inputYear} this w/m/y</div>
                <div>Search: {userProfile.analytics.searchToday}/{userProfile.analytics.searchMonth}/{userProfile.analytics.searchYear} this w/m/y</div>
            </div>
            <Button
                id="user-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <i className="fa fa-user" aria-hidden="true"></i>
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={() => {
                    LoginApi.Logout()
                        .then(() => {
                            window.location.reload();
                        });

                }}>Logout</MenuItem>
            </Menu>
        </>
    )
};

export default RightMenu;